<div [ngClass]="dialogTypeClass" class="dialog-wrapper" [id]="id">
  <h1 *ngIf="hasDialogTitle" class="dialog-title" [attr.id]="role ? role + 'heading' : null">
    {{
      preserveTitleFormatting
        ? dialogTitle
        : isEnglishTitle
          ? (dialogTitle | titlecase)
          : (dialogTitle | lowercase | capitalizeFirstLetter)
    }}
  </h1>
  <div class="dialog-content">
    <div [ngClass]="{ 'inner-html': true, 'line-breaks': supportLineBreaks }" [innerHTML]="config.data.text"></div>
    <div #extracomponent *ngIf="!!config.data.extraComponent" class="extra-component"></div>
    <div
      class="extra-information"
      *ngIf="!!config.data.extraInformation"
      [innerHTML]="config.data.extraInformation"
      [ngClass]="{ 'line-breaks': supportLineBreaks }"
    ></div>
    <button
      *ngIf="!!config.data.tertiaryAction && !!config.data.tertiaryActionLabel"
      pButton
      type="button"
      class="p-button-text dialog-tertiary"
      (click)="onTertiaryActionClick()"
    >
      {{ config.data.tertiaryActionLabel }}
    </button>
    <span class="timer" *ngIf="config.data?.timeLimit">
      Click <strong>ok</strong> to continue or you will automatically be redirected in {{ countDown }} secods.
    </span>
  </div>
  <div class="dialog-footer">
    <app-button
      secondary
      *ngIf="config.data.rejectable"
      (buttonClicked)="reject()"
      [ignoreReadOnly]="config.data.ignoreReadOnlyRejectButton"
      dataCy="dialog-cancel-button"
    >
      {{ rejectButtonText ? rejectButtonText : (GLOBAL_STRINGS.CANCEL | translateString) }}
    </app-button>
    <app-button
      #acceptbutton
      (buttonClicked)="accept()"
      dataCy="dialog-confirm-button"
      [ignoreReadOnly]="config.data.ignoreReadOnlyAcceptButton"
    >
      {{ acceptButtonText ? acceptButtonText : (GLOBAL_STRINGS.CONFIRM | translateString) }}
    </app-button>
  </div>
</div>
